
import Odoo from "../../../../assets/WhiteOddoCircle.svg";

export const json = [
  {
    endpoint: "url1/url2",
    method: "POST",
    name: "OdooPost",
    description: "4free",
    type: "Odoo",
    image: Odoo,
    data: [
      {
        type: "type 1",
        required: true,
        description: "Description Variable 1",
        title: "Title Variable 1",
      },
      {
        type: "type 2",
        required: true,
        description: "Description Variable 2",
        title: "Title Variable 2",
      },
      {
        type: "type 3",
        required: true,
        description: "Description Variable 3",
        title: "Title Variable 3",
      },
      {
        type: "type 4",
        required: true,
        description: "Description Variable 4",
        title: "Title Variable 4",
      },
    ],
  },
  {
    endpoint: "url1/url2",
    method: "GET",
    name: "OdooGet",
    description: "4free",
    type: "Odoo",
    image: Odoo,
    data: [
      {
        type: "type 1",
        required: true,
        description: "Description Variable 1",
        title: "Title Variable 1",
      },
      {
        type: "type 2",
        required: true,
        description: "Description Variable 2",
        title: "Title Variable 2",
      },
      {
        type: "type 3",
        required: true,
        description: "Description Variable 3",
        title: "Title Variable 3",
      },
      {
        type: "type 4",
        required: true,
        description: "Description Variable 4",
        title: "Title Variable 4",
      },
    ],
  },
  {
    endpoint: "url1/url2",
    method: "PUT",
    name: "OdooPut",
    description: "4free",
    type: "Odoo",
    image: Odoo,
    data: [
      {
        type: "type 1",
        required: true,
        description: "Description Variable 1",
        title: "Title Variable 1",
      },
      {
        type: "type 2",
        required: true,
        description: "Description Variable 2",
        title: "Title Variable 2",
      },
      {
        type: "type 3",
        required: true,
        description: "Description Variable 3",
        title: "Title Variable 3",
      },
      {
        type: "type 4",
        required: true,
        description: "Description Variable 4",
        title: "Title Variable 4",
      },
    ],
  },
  {
    endpoint: "url1/url2",
    method: "PATCH",
    name: "OdooPatch",
    description: "4free",
    type: "Odoo",
    image: Odoo,
    data: [
      {
        type: "type 1",
        required: true,
        description: "Description Variable 1",
        title: "Title Variable 1",
      },
      {
        type: "type 2",
        required: true,
        description: "Description Variable 2",
        title: "Title Variable 2",
      },
      {
        type: "type 3",
        required: true,
        description: "Description Variable 3",
        title: "Title Variable 3",
      },
      {
        type: "type 4",
        required: true,
        description: "Description Variable 4",
        title: "Title Variable 4",
      },
    ],
  },
  {
    endpoint: "url1/url2",
    method: "DELETE",
    name: "OdooDelete",
    description: "4free",
    type: "Odoo",
    image: Odoo,
    data: [
      {
        type: "type 1",
        required: true,
        description: "Description Variable 1",
        title: "Title Variable 1",
      },
      {
        type: "type 2",
        required: true,
        description: "Description Variable 2",
        title: "Title Variable 2",
      },
      {
        type: "type 3",
        required: true,
        description: "Description Variable 3",
        title: "Title Variable 3",
      },
      {
        type: "type 4",
        required: true,
        description: "Description Variable 4",
        title: "Title Variable 4",
      },
    ],
  },
];
